import React, { useState } from "react";
import { useSelector } from "react-redux";
import Header from "../pages/header";
import TrialBanner from "../components/TrialBanner";

export default (WrappedComponent) => {
  const HocComponent = (props) => {
    const { user } = useSelector((state) => state.auth);
    const [showBanner, setShowBanner] = useState(true);

    return (
      <div id="wrapper">
        <Header />

        <div className="global-trial-banner">
          <TrialBanner user={user} />
        </div>

        <WrappedComponent {...props} />
      </div>
    );
  };

  return HocComponent;
};
